import React from 'react'
import { useParams } from 'react-router-dom'
import { Grid, Stack, Divider, Typography, Box, Card } from '@mui/material'
import { useGetCustomerQuery, useGetSupplierTypesQuery, useGetVendorClassesQuery } from 'services/customers'
import { useGetPriceSheetQuery, useGetPriceSheetsQuery } from 'services/priceSheets'
import { AnalyticsContainer } from 'components/containers'
import useGlobalLoader from 'utils/custom-hooks/useGlobalLoader'
import { useCustomerHeader } from './utils'
import CustomerProfileInfo from './CustomerProfileInfo'
import { useSelector } from 'react-redux'
import CarrierProfileInfo from './CarrierProfileInfo.jsx'

const Customer = () => {
  const { id: customerId } = useParams()
  const { data: customerData, isLoading: isLoadingCustomerData } = useGetCustomerQuery(
    { customerId },
    { skip: !customerId },
  )
  const { isLoading: isLoadingPriceSheetData } = useGetPriceSheetQuery(
    { priceSheetId: customerData?.priceSheetId },
    { skip: !customerData?.priceSheetId },
  )
  const { isLoading: isLoadingSupplierTypes } = useGetSupplierTypesQuery({})
  const { isLoading: isLoadingVendorClasses } = useGetVendorClassesQuery({})
  const { isLoading: isLoadingPriceSheetsData } = useGetPriceSheetsQuery({
    filter: JSON.stringify({ type: 'PRICE_LIST' }),
  })
  const isLoading =
    isLoadingCustomerData ||
    isLoadingPriceSheetData ||
    isLoadingSupplierTypes ||
    isLoadingVendorClasses ||
    isLoadingPriceSheetsData

  useCustomerHeader(customerData)
  useGlobalLoader(isLoading)

  // TODO: make a new comp for the carrier version of Customerprofileinfo

  return (
    <Stack>
      {customerData?.isCarrier ? (
        <CarrierProfileInfo customerData={customerData} />
      ) : (
        <Grid container columns={3}>
          <Grid item xs={1}>
            <CustomerProfileInfo customerData={customerData} />
          </Grid>
          <Divider orientation="vertical" flexItem style={{ marginRight: '-1px' }} />
          <Grid item xs={2} padding={3}>
            <AnalyticsContainer dashboard="inbound-customer" customParams={{ customerid: customerId }} />
          </Grid>
        </Grid>
      )}
    </Stack>
  )
}

export default Customer
